<template>
  <div class="calm">
    <div class="title_color">
      亚马逊商品利润计算系统 <span class="title-tip">(适用于FBA卖家)</span>
      <span class="currency">
        <span class="right">
          <span>实时汇率({{updateTime}}) </span>
          <!--      货币汇率-->
          <span v-for="(item, index) in currencyExchange" :key="index" style="margin: 0 5px">
            <img :src="countryIcon[index]" alt="">{{country[index]}}:{{item.rate.toFixed(4)}}
          </span>
        </span>
      </span>
    </div>
    <div class="calm_module">
      <inputModule class="module_input"></inputModule>
    </div>

  </div>
</template>

<script>
  import inputModule from "../content/inputModule";
  // 网络请求
  import {request} from "@/network/request";
  export default {
    name: "calmModule",
    data(){
      return{
        // 汇率更新时间
        updateTime: '',
        // 对应货币汇率
        currencyExchange: [],
        country: ['美元', '加元', '英镑', '欧元', '日元', '澳元'],
        countryIcon: [require('../../img/美国.jpg'),
                      require('../../img/加拿大.jpg'),
                      require('../../img/英国.jpg'),
                      require('../../img/欧洲.jpg'),
                      require('../../img/日本.jpg'),
                      require('../../img/澳洲.jpg')]
      }
    },
    components: {
      'inputModule': inputModule
    },
    created() {
      request({
        url: '/info/getExchangeRate',
        method: 'post',
        // header: {
        //   'Content-Type': 'application/json'
        // }
      }).then(res => {
        if(res.data.code === 1){
          this.updateTime = res.data.info.refreshTime;
          this.currencyExchange = res.data.info.rates;
        }else if(res.data.code === 1020){
          sessionStorage.removeItem('JSESSIONID')
          request({
            url: '/info/getExchangeRate',
            method: 'POST',
          }).then(res => {
            if(res.data.code === 1){
              this.updateTime = res.data.info.refreshTime;
              this.currencyExchange = res.data.info.rates;
            }
          })
        }
      })
    }
  }
</script>

<style scoped>
  .calm{
    background-color: white;
    width: 70%;
  }

  .title_color{
    color: #000;
    text-align: start;
    font-weight: bold;
    border-bottom: 1px solid #f1f4f9;
  }

  .title-tip{
    color: #19ACFD;
  }

  .title_color:after{
    content:'';
    display: block;
    border-bottom:5px solid #ff7f17;
  }

  .currency span{
    color: #7f7f7f;
    font-weight: 400;
    line-height: 20px;
  }

  .calm_module{
    display: flex;
    justify-content: center;
    padding: 0 10px;
  }

  @media screen and (max-width: 1600px) {
    .calm{
      padding: 0.9rem 0;
      border-radius: 1rem;
      margin: 0.9rem 0;
    }

    .title_color{
      margin: 0 1rem 0.9rem;
      font-size: 1.7rem;
      padding-top: 0.3rem;
    }

    .title-tip{
      font-size: 1.7rem;
    }

    .title_color:after{
      width: 1.8rem;
      margin-left: 8rem;
    }

    .title_color img{
      width: 1.5rem;
      height: 1.2rem;;
      margin: 0 0.2rem -3px;
    }

    .calm_module{
      margin: 0.9rem auto 0 ;
    }

    .currency span{
      height: 2rem;
      font-size: 0.5rem;
    }
  }

  @media screen and (min-width: 1600px){
    .calm{
      padding: 10px 0;
      border-radius: 10px;
      margin: 10px 0;
    }

    .title_color{
      margin: 0 30px 10px;
      font-size: 20px;
      padding-top: 5px;
    }

    .title-tip{
      font-size: 20px;
    }

    .title_color:after{
      width: 20px;
      margin-left: 100px;
    }

    .currency span{
      height: 20px;
      font-size: 12px;
    }

    .title_color img{
      width: 15px;
      height: 12px;
      margin: 0 2px -1px;
    }

    .calm_module{
      margin: 10px auto 0 ;
    }
  }
</style>
